/*
    Copyright (C) 2023 - Wheel and Brake - Southwest Airlines
*/
import TagForm from "./TagForm";
import "../commons/Form.css";

const CreateTag = () => {
  return (<TagForm/>);
};

export default CreateTag;